import React from "react";
import * as PropTypes from "prop-types";
import { Navbar, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ROLES } from "./common/Const";
import LanguageSwitcher from './common/LanguageSwitcher';
import { useTranslation } from 'react-i18next';

function HeaderNav({ user, signOut }) {
  const { t: tr } = useTranslation();
  const menuItems = [
    { name: tr("public:timetable.title"), route: "/grafik" },
    { name: tr("public:school"), route: "/#SchoolPage" },
    { name: tr("public:offer"), route: "/#OfferPage" },
    { name: tr("public:contactPayment"), route: "/#ContactPage" },
    { name: tr("common:enrollments"), route: "/signup" },
    { name: tr("public:gallery"), route: "/gallery" },
    { name: "Quiz English", route: "/quiz" },
    { name: tr("public:news"), route: "/news" },
  ];

  return (
    <Navbar
      collapseOnSelect
      expand="xl"
      id="nav"
      className="custom-nav  fixed-top px-4 py-1"
    >
      <Navbar.Brand as={Link} to="/" className="py-0">
        <img
          src="/resources/app/logo.ico"
          alt="Extra English"
          width="60px"
          height="60px"
          className="custom-nav-logo"
        />
      </Navbar.Brand>
      <LanguageSwitcher />
      <Navbar.Toggle label={tr("common:toggleNavigation")} aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="mr-auto">
          {menuItems.map((item) => (
            <Nav.Link
              as={Link}
              eventKey={item.route}
              key={item.route}
              to={item.route}
              className="custom-nav-link ml-1 my-0"
            >
              {item.name}
            </Nav.Link>
          ))}
        </Nav>
        <Nav>
          {user && user.role !== ROLES.GUEST ? (
            <Nav.Link
              as="button"
              type="button"
              eventKey="logout"
              title={tr("common:signOut")}
              aria-label={tr("common:signOut")}
              onClick={signOut}
              className="custom-nav-link ml-1 mb-0 border-0 bg-transparent"
            >
              <i className="fas fa-sign-in-alt fa-lg" />
            </Nav.Link>
          ) : (
            <Nav.Link
              as={Link}
              eventKey="1"
              to="/manage"
              title={tr("common:signIn")}
              aria-label={tr("common:signIn")}
              className="custom-nav-link ml-1 mb-0"
            >
              <i className="fas fa-sign-in-alt fa-lg" />
            </Nav.Link>
          )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

HeaderNav.propTypes = {
  user: PropTypes.object,
  signOut: PropTypes.func,
};

HeaderNav.defaultProps = {
  user: null,
  signOut: () => {},
};

export default HeaderNav;
